module.exports = __webpack_public_path__ + "bae478dec3c0aaed0b14e118f367a61c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg36.jpeg
// module id = 46
// module chunks = 0